(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qed-content-block"] && !Shopify.designMode) return;
  try {
    
  /*
    QED read more. When a section sets "Collapse long text after (words)", the first prose group
    is cut after that many words and the remainder moved into a hidden element, with an inline
    "Read more" link. Clicking it restores the original markup exactly and removes the link. The full text is always in
    the DOM, so nothing is lost to search engines or to users without JavaScript (who see it all).
  */
  class QedReadMore extends HTMLElement {
    connectedCallback() {
      this.limit = parseInt(this.getAttribute('words'), 10) || 0;
      this.prose = this.querySelector('.prose');

      if (!this.limit || !this.prose || this.toggle) {
        return;
      }

      const words = this.prose.textContent.trim().split(/\s+/).length;

      // Not worth a toggle for a handful of extra words.
      if (words <= this.limit + 15) {
        return;
      }

      this.full = this.prose.innerHTML;
      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.className = 'qed-read-more__toggle';
      this.toggle.addEventListener('click', () => this.expand());
      this.collapse();
    }

    collapse() {
      this.prose.innerHTML = this.full;

      const walker = document.createTreeWalker(this.prose, NodeFilter.SHOW_TEXT);
      let count = 0, node;

      while ((node = walker.nextNode())) {
        const re = /\S+/g;
        let match;

        while ((match = re.exec(node.data))) {
          count += 1;

          if (count === this.limit) {
            const range = document.createRange();
            range.setStart(node, match.index + match[0].length);
            range.setEndAfter(this.prose.lastChild);

            const rest = document.createElement('div');
            rest.className = 'qed-read-more__rest';
            rest.appendChild(range.extractContents());
            this.prose.appendChild(rest);

            node.data = node.data.replace(/\s*$/, '') + '\u2026 ';
            node.parentNode.insertBefore(this.toggle, node.nextSibling);
            this.setState(false);
            return;
          }
        }
      }
    }

    // One way only: once opened the full text stays and the link goes.
    expand() {
      this.prose.innerHTML = this.full;
      this.expanded = true;
    }

    setState(expanded) {
      this.expanded = expanded;
      this.toggle.textContent = 'Read more';
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('qed-read-more')) {
    customElements.define('qed-read-more', QedReadMore);
  }

  } catch(e) { console.error(e); }
})();
})();
